export default {
	name: 'SettingsContainer'
}